import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Font,
  Alignment,
  List,
  Link as CKLink,        // ✅ rename to avoid collision
  BlockQuote,
  Table as CKTable,
  TableToolbar,
  Image as CKImage,
  ImageUpload,
  ImageToolbar,
  ImageStyle,
  ImageResize,
  SimpleUploadAdapter,
  HorizontalLine,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";
const AddBlogPage = () => {
const navigate = useNavigate();
  // =========================
  // STATE
  // =========================
const [isSubmitting, setIsSubmitting] = useState(false);
  const [title, setTitle] = useState("");
  const [sbTitle, setSbTitle] = useState("");
    const [description, setDescription] = useState("");
  const [getYoutubeLink, setYoutubeLink] = useState("");
  const [content, setContent] = useState("");

  // SEO
  const [metaKey, setMetaKey] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [keyword, setKeyword] = useState("");
    const [autherName, setAutherName] = useState("");

  // MAIN MULTIPLE IMAGES
  const [pageimg, setPageimg] = useState([]);
  const [preview, setPreview] = useState([]);
const [addedBy, setaddedBy] = useState("");
  // EXTRA IMAGE TABLE
  const [imageRows, setImageRows] = useState([
    {
      image: null,
      preview: "",
      altTitle: ""
    }
  ]);
 const [updatedDate, setUpdatedDate] = useState(
  new Date().toISOString().split("T")[0]
);
  const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  // =========================
  // CLEANUP IMAGE URL
  // =========================

  useEffect(() => {

    return () => {
      preview.forEach((url) => URL.revokeObjectURL(url));

      imageRows.forEach((row) => {
        if (row.preview) {
          URL.revokeObjectURL(row.preview);
        }
      });
    };

  }, [preview, imageRows]);

  useEffect(() => {
      fetchCategoryData();
      fetchTagsyData();
  }, []);

  const fetchCategoryData = async () => {
    try {
      const res = await api.get("/adminBlog/getCategoryDataBlog");
      setCategories(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load category data");
    }
  };

const fetchTagsyData = async () => {
    try {
      const res = await api.get("/adminBlog/getTagDataBlog");
      setTags(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Tags data");
    }
  };

const handleTagChange = (slug) => {

  setSelectedTags((prev) =>

    prev.includes(slug)
      ? prev.filter((tag) => tag !== slug)
      : [...prev, slug]

  );

};

  // =========================
  // MAIN IMAGE CHANGE
  // =========================

  const handleImageChange = (e) => {

    const files = Array.from(e.target.files);

    setPageimg(files);

    const previewUrls = files.map((file) =>
      URL.createObjectURL(file)
    );

    setPreview(previewUrls);

  };

const blogLink = title
                  .toLowerCase()
                  .trim()
                  .replace(/[^\w\s-]/g, "")
                  .replace(/\s+/g, "-");

useEffect(() => {
  setImageRows((prev) =>
    prev.map((row, index) => ({
      ...row,
      altTitle: blogLink
        ? `${blogLink}-${index + 1}`
        : ""
    }))
  );
}, [blogLink]);

  // =========================
  // DELETE PREVIEW IMAGE
  // =========================

  const handleDeletePreviewImage = async (index) => {

    const confirm = await Swal.fire({
      title: "Remove Image?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    const updatedPreview = preview.filter(
      (_, i) => i !== index
    );

    const updatedFiles = pageimg.filter(
      (_, i) => i !== index
    );

    setPreview(updatedPreview);
    setPageimg(updatedFiles);

  };

  // =========================
  // EXTRA IMAGE ROWS
  // =========================

  // const addImageRow = () => {

  //   setImageRows([
  //     ...imageRows,
  //     {
  //       image: null,
  //       preview: "",
  //       altTitle: ""
  //     }
  //   ]);

  // };


  const addImageRow = () => {
  setImageRows([
    ...imageRows,
    {
      image: null,
      preview: "",
      altTitle: `${blogLink}-${imageRows.length + 1}`
    }
  ]);
};

  const removeImageRow = async (index) => {

    if (imageRows.length === 1) {
      toast.error("At least one row required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Row?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    const updated = imageRows.filter(
      (_, i) => i !== index
    );

    setImageRows(updated);

  };

  const handleRowImageChange = (
    index,
    file
  ) => {

    const updatedRows = [...imageRows];

    updatedRows[index].image = file;
    updatedRows[index].preview =
      URL.createObjectURL(file);

    setImageRows(updatedRows);

  };

  const handleAltTitleChange = (
    index,
    value
  ) => {

    const updatedRows = [...imageRows];

    updatedRows[index].altTitle = value;

    setImageRows(updatedRows);

  };

  // =========================
  // SAVE BLOG
  // =========================

  const saveBlog = async () => {

    if (!title) {
      toast.error("Title is required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Save Blog?",
      text: "Do you want to save this Blog?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Save"
    });

    if (!confirm.isConfirmed) return;
   setIsSubmitting(true);
    try {

      const blogLink = title
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");

      const formData = new FormData();
updatedDate
      // BLOG DATA
      formData.append("blogLink", blogLink);
        formData.append("addedBy", addedBy);
        
         formData.append("youTube_link", getYoutubeLink);
        formData.append("addedDt", updatedDate);
       formData.append("autherName", autherName);
      formData.append("title", title);
      formData.append("sbTitle", sbTitle);
      // CATEGORY
formData.append("category", selectedCategory);

// TAGS (IMPORTANT: array send as JSON)
formData.append("tags", JSON.stringify(selectedTags));
      formData.append("description", description);
      formData.append("pageContent", content);

      // SEO
      formData.append("metaKey", metaKey);
      formData.append(
        "metaDescription",
        metaDescription
      );
      formData.append("keyword", keyword);

      // MAIN MULTIPLE IMAGES
      pageimg.forEach((img) => {
        formData.append("pageimg", img);
      });

      // EXTRA TABLE IMAGES
      // console.log(imageRows);return false;
      // imageRows.forEach((row, index) => {

      //   if (row.image) {
      //     formData.append(
      //       "extraImages",
      //       row.image
      //     );
      //   }

      //   formData.append(
      //     `altTitle_${index}`,
      //     row.altTitle
      //   );

      // });
imageRows.forEach((row, index) => {

  if (row.image) {
    formData.append("extraImages", row.image);
  }

  formData.append(
    `altTitle_${index}`,
    `${blogLink}-${index + 1}`
  );

});
      // API
      const res = await api.post(
        "/adminBlog/saveBlog",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

      // SUCCESS
      if (res.data.success) {

        Swal.fire(
          "Success",
          "Blog Saved Successfully",
          "success"
        );
        navigate("/blog-manage");
        // RESET
        setTitle("");
        setSbTitle("");
        setDescription("");
        setYoutubeLink("");
        setContent("");

        setMetaKey("");
        setMetaDescription("");
        setKeyword("");

        setPageimg([]);
        setPreview([]);

        setImageRows([
          {
            image: null,
            preview: "",
            altTitle: ""
          }
        ]);

        // NAVIGATE TO BLOG MANAGE PAGE
        
      } else {
  navigate("/blog-manage");
        Swal.fire(
          "Error",
          res.data.message,
          "error"
        );

      }

    } catch (error) {
  navigate("/blog-manage");
      console.log(error);

      // toast.error("Server Error");

    }
    finally {

    setIsSubmitting(false);

  }

  };

  // =========================
  // JSX
  // =========================

  return (

    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}

      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">

        <div className="card-body d-flex justify-content-between align-items-center">

          <h4 className="fw-bold mb-0">
            Add Blog
          </h4>

          <Link
            to="/blog-manage"
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back
          </Link>

        </div>

      </div>

      <div className="row">

        {/* LEFT SIDE */}

        <div className="col-lg-12">

          <table className="table table-bordered">

            <tbody>

              {/* BLOG LINK */}

              {title.length > 0 && (

                <tr>

                  <th colSpan={2}>

                    <div className="d-flex align-items-center gap-2">

                      <i
                        className="fa fa-link text-primary"
                        aria-hidden="true"
                      ></i>

                      <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={blogLink}
                      />

                    </div>

                  </th>

                </tr>

              )}
              
       
              {/* META Title */}

              <tr>
                <th colSpan={2}>   <div className="d-flex align-items-center gap-2">
                    <span>Meta Title</span>
                    <small className={`d-block mt-1 ${
  metaKey.length > 80 ? "text-danger" : "text-muted"
}`}>
  ({metaKey.length}/80 Characters)
</small>
               </div>
                </th>
              </tr>

              <tr>

                <td colSpan={2}>

                 <input
  type="text"
  className="form-control"
  placeholder="Enter Meta Title"
  value={metaKey}
  maxLength={80}
  onChange={(e) => setMetaKey(e.target.value)}
/>



{metaKey.length >= 79 && metaKey.length <= 80 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}

                </td>

              </tr>

              {/* META DESCRIPTION */}

              <tr>
                <th colSpan={2}>
                  <div className="d-flex align-items-center gap-2">
                    <span>Meta Description</span>
                    <small className={`d-block mt-1 ${
  metaDescription.length > 160 ? "text-danger" : "text-muted"
}`}>
  ({metaDescription.length}/160 Characters)
</small>
                  </div>
                  
                </th>
              </tr>

              <tr>

                <td colSpan={2}>

                  <textarea
                    rows="3"
                    className="form-control"
                    placeholder="Enter Meta Description"
                    value={metaDescription}
                    maxLength={160}
                    onChange={(e) =>
                      setMetaDescription(
                        e.target.value
                      )
                    }
                  ></textarea>


{metaDescription.length >= 159 && metaDescription.length <= 160 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                </td>

              </tr>

              {/* KEYWORD */}

              <tr>
                <th colSpan={2}>
                  <div className="d-flex align-items-center gap-2">
                 <span>Meta Keyword  </span><small className={`d-block mt-1 ${
  keyword.length > 255 ? "text-danger" : "text-muted"
}`}>
  ({keyword.length}/255 Characters)
</small>
</div>
                </th>
              </tr>

              <tr>

                <td colSpan={2}>

                 <textarea
                  rows="3"
                    className="form-control"
                    placeholder="Enter Keyword"
                    value={keyword}
                      maxLength={255}
                    onChange={(e) =>
                      setKeyword(
                        e.target.value
                      )
                    }
                  ></textarea>


{keyword.length >= 254 && keyword.length <= 255 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                </td>

              </tr>
                 <tr>
                <th >
                  Author Name
                </th>
                 <th>Date</th>
              </tr>
               <tr>

                <td>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Author Name"
                    value={autherName}
                    onChange={(e) =>
                      setAutherName(e.target.value)
                    }
                  />

                </td>
                  <td>
      

<input
  className="form-control"
  type="date"
  value={updatedDate}
  onChange={(e) =>
    setUpdatedDate(e.target.value)
  }
/>
                </td>
                </tr>
 <tr>
                <th>Blog Category</th>
                <th>Blog Tags</th>
              </tr>
               <tr>

                <td>
{/* <pre>{JSON.stringify(tags, null, 2)}</pre> */}
        

<select
  className="form-control"
  value={selectedCategory}
  onChange={(e) => setSelectedCategory(e.target.value)}
>
  <option value="" hidden>-- Select Category --</option>

  {categories.map((cat) => (
    <option key={cat.cat_id} value={cat.slug}>
      {cat.name}
    </option>
  ))}
</select>

                </td>

                <td style={{width:"50%"}}>
<div className="d-flex flex-wrap gap-3">

  {tags.map((tag) => (

    <div key={tag.tags_id} className="form-check">

      <input
        className="form-check-input"
        type="checkbox"
        id={`tag-${tag.slug}`}

        checked={selectedTags.includes(tag.slug)}

        onChange={() =>
          handleTagChange(tag.slug)
        }
      />

      <label
        className="form-check-label ms-1"
        htmlFor={`tag-${tag.slug}`}
      >
        {tag.name}
      </label>

    </div>

  ))}

</div>

                </td>

              </tr>
              {/* TITLE */}

              <tr>
                <th>Page Title</th>
                <th>Page Sub Title</th>
              </tr>

              <tr>

                <td>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Blog Title"
                    value={title}
                    onChange={(e) =>
                      setTitle(e.target.value)
                    }
                  />

                </td>

                <td>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Sub Title"
                    value={sbTitle}
                    onChange={(e) =>
                      setSbTitle(e.target.value)
                    }
                  />

                </td>

              </tr>
{/*YOU TUBE LINK AREA SRAER */}
 <tr>
                <th colSpan={2}>
                  You Tube Link
                </th>
              </tr>
              <tr>

                <td colSpan={2}>

                  <textarea
                    rows="4"
                    className="form-control"
                    placeholder="Enter You Tube Link"
                    value={getYoutubeLink}
                    onChange={(e) =>
                      setYoutubeLink(
                        e.target.value
                      )
                    }
                  ></textarea>

                </td>

              </tr>
{/* YOU TUBE LINK AREA END */}

              {/* DESCRIPTION */}

              <tr>
                <th colSpan={2}>
                  Page Description
                </th>
              </tr>

              <tr>

                <td colSpan={2}>

                  <textarea
                    rows="4"
                    className="form-control"
                    placeholder="Enter Description"
                    value={description}
                    onChange={(e) =>
                      setDescription(
                        e.target.value
                      )
                    }
                  ></textarea>

                </td>

              </tr>

              {/* CKEDITOR */}

              <tr>
                <th colSpan={2}>
                  Page Detailed Content
                </th>
              </tr>

              <tr>

                {/* <td colSpan={2}>

                  <CKEditor
                    editor={ClassicEditor}
                    data={content}
                    onChange={(
                      event,
                      editor
                    ) => {

                      const data =
                        editor.getData();

                      setContent(data);

                    }}
                      config={{
    simpleUpload: {
      uploadUrl:
        "http://localhost:5000/api/upload-editor-image"
    },

    toolbar: [
      "heading",
      "|",
      "bold",
      "italic",
      "link",
      "bulletedList",
      "numberedList",
      "|",
      "blockQuote",
      "insertTable",
      "undo",
      "redo"
    ]
  }}
                  />

                  

                </td> */}
<td colSpan={2}>
  <CKEditor
  editor={ClassicEditor}
  data={content}
  config={{
    licenseKey: "GPL",
    plugins: [
      Essentials,
      Paragraph,
      Heading,
      Bold,
      Italic,
      Underline,
      Font,
      Alignment,
      List,
      CKLink,
      BlockQuote,
      CKTable,
      TableToolbar,
      CKImage,
      ImageUpload,
      ImageToolbar,
      ImageStyle,
      ImageResize,
      SimpleUploadAdapter,
      HorizontalLine,
    ],
    toolbar: [
      "heading", "|",
      "bold", "italic", "underline", "|",
      "fontSize", "fontColor", "fontBackgroundColor", "|",
      "alignment", "|",
      "bulletedList", "numberedList", "|",
      "link", "blockQuote", "insertTable", "|",
      "imageUpload", "horizontalLine", "|",
      "undo", "redo",
    ],
    table: {
      contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
    },
    simpleUpload: {
      uploadUrl: "http://localhost:5000/api/upload-editor-image", // ✅ tumhara real backend endpoint
    },
  }}
  onChange={(event, editor) => {
    const data = editor.getData();
    setContent(data);
  }}
/>
</td>
              </tr>


              {/* EXTRA IMAGE TABLE */}

              <tr>

                <th colSpan={2}>

                  <table className="table table-hover table-bordered align-middle mb-0">

                    <thead className="table-light">

                      <tr>
                        <th width="50">
                          #
                        </th>

                        <th>
                          Upload Image
                        </th>

                        <th>
                          Alt Title
                        </th>

                        <th width="120">
                          Action
                        </th>
                      </tr>

                    </thead>

                    <tbody>

                      {imageRows.map(
                        (row, index) => (

                          <tr key={index}>

                            <td>
                              {index + 1}
                            </td>

                            <td>

                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={(e) =>
                                  handleRowImageChange(
                                    index,
                                    e.target
                                      .files[0]
                                  )
                                }
                              />

                            

                            </td>

                            <td>

                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Alt Title"
                                readOnly
                          //  value={blogLink ? `${blogLink}-${index + 1}` : ""}
                           value={row.altTitle}
                                // onChange={(e) =>
                                //   handleAltTitleChange(
                                //     index,
                                //     e.target
                                //       .value
                                //   )
                                // }
                              />

                            </td>

                            <td>

                              <button
                                type="button"
                                className="btn btn-success btn-sm me-2"
                                onClick={
                                  addImageRow
                                }
                              >
                                <i className="fa fa-plus-square"></i>
                              </button>

                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                  removeImageRow(
                                    index
                                  )
                                }
                              >
                                <i className="fa fa-trash"></i>
                              </button>

                            </td>

                          </tr>

                        )
                      )}

                    </tbody>

                  </table>

                </th>

              </tr>
           
<tr>
  <th colSpan={2}>Added By</th>
  </tr>
              <tr>
                <td colSpan={2}>
                 <input
  className="form-control"
  placeholder="Enter Name"
  type="text"
  value={addedBy}
  onChange={(e) =>
    setaddedBy(e.target.value)
  }
/>

                </td>
              
              </tr>

            </tbody>

          </table>

        </div>

        {/* RIGHT SIDE */}

      

        {/* SAVE BUTTON */}

        <div className="col-lg-12 text-center">

     <button
  className="btn btn-info text-white px-5 mt-3"
  onClick={saveBlog}
  disabled={isSubmitting}
>
  {isSubmitting ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
      ></span>
      Submitting...
    </>
  ) : (
    "Save Blog"
  )}
</button>

        </div>

      </div>

    </div>

  );

};

export default AddBlogPage;